var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Simple Stock Transfer Order"}},[_c('div',{staticClass:"vx-input-group flex"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Open"}},[_c('tab-open')],1),_c('vs-tab',{attrs:{"label":"Received"}},[_c('tab-received')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }